// extracted by css-extract-rspack-plugin
export default {"headerIcon":"opZ2i2_XtYIsW37i","countBadge":"g1Yf9ZmsS8YhdAfM","skeleton":"i9xgays09XE1Ob98","pulse":"A8O8QygiZgF3sJza"};